module.exports = "<svg viewBox=\"0 0 24 24\"><polygon points=\"11.915701 9.96082949 6.28206042 4.34447005 4.39841986 6.40092166 10.0320604 12.0172811 4.41570097 17.6336406 6.26477931 19.65553 11.8811388 14.0391705 17.4974982 19.6382488 19.3811388 17.5990783 13.7647793 12 19.3984199 6.36635945 17.5320604 4.34447005\"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/close.svg
// module id = 746
// module chunks = 0